import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoginPage } from 'src/app/pages/login/login.page';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { OktaService } from 'src/app/services/okta.service';
import { StorageService } from 'src/app/services/storage.service';
import { LOGIN_REQUIRED_CONFIGS } from 'src/app/utils/Constants';

@Component({
  selector: 'app-pre-configuration-modal',
  templateUrl: './pre-configuration-modal.component.html',
  styleUrls: ['./pre-configuration-modal.component.scss'],
  standalone: false,
})
export class PreConfigurationModalComponent implements OnInit {
  selectedOption: string = 'entire-window';
  isLoggedIn: boolean = false;
  disableNextBtn: boolean = false;
  constructor(private modalController: ModalController, private oktaService: OktaService,
    private storageService: StorageService, private modalHelper: ModalHelperService
  ) { }

  async ngOnInit() {
    const authStatus = await this.oktaService.isUserAuthenticated();
    this.isLoggedIn = authStatus
  }

  // selectOption(option: string) {
  //   if ((LOGIN_REQUIRED_CONFIGS.includes(option) && this.isLoggedIn) || !LOGIN_REQUIRED_CONFIGS.includes(option)) {
  //     this.disableNextBtn = false;
  //     this.selectedOption = option;
  //   } else {
  //     this.disableNextBtn = true;
  //   }
  // }
  selectOption(option: string) {
    this.selectedOption = option;
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  get showLoginButton(): boolean {
    return this.selectedOption === 'glass-only' && !this.isLoggedIn;
  }

  async login() {
    const modal = await this.modalController.create({
      component: LoginPage,
      cssClass: 'configuration-modal'
    });

    await modal.present();
    await modal.onDidDismiss();
    this.modalHelper.closeAllModals();
  }

  async next() {
    if (!this.selectedOption) return;

    const saveOnlyGlass = this.selectedOption === 'glass-only';
    // Read current main project
    const raw = localStorage.getItem('iCaluwin-LastProject');
    const mainProject = raw ? JSON.parse(raw) : {};

    // Apply change
    mainProject.saveOnlyGlass = saveOnlyGlass;
    localStorage.setItem('iCaluwin-LastProject', JSON.stringify(mainProject));

    this.modalController.dismiss({ selectedOption: this.selectedOption }, 'confirm');
  }

  dismiss() {
    this.modalController.dismiss(null, 'dismiss');
  }

}
